import { render, staticRenderFns } from "./ViewTeacherFeedback.vue?vue&type=template&id=e200f440&scoped=true"
import script from "./ViewTeacherFeedback.vue?vue&type=script&lang=js"
export * from "./ViewTeacherFeedback.vue?vue&type=script&lang=js"
import style0 from "./ViewTeacherFeedback.vue?vue&type=style&index=0&id=e200f440&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e200f440",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e200f440')) {
      api.createRecord('e200f440', component.options)
    } else {
      api.reload('e200f440', component.options)
    }
    module.hot.accept("./ViewTeacherFeedback.vue?vue&type=template&id=e200f440&scoped=true", function () {
      api.rerender('e200f440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/ViewTeacherFeedback.vue"
export default component.exports